import React, {useCallback, useEffect} from "react";
import DateInterval from "components/common/form/DateInterval";
import {Button, Grid2} from "@mui/material";
import CompanySelect from "components/global/CompanySelect";
import {connect} from "react-redux";
import actions, {FILM_RELEASE_REPORT_SEARCH_FORM} from "./logic/actions";
import {useStateWithCallbackLazy} from "use-state-with-callback";

function FilmReleaseSearchFormView({
    onChangeForm, statisticsForm
}) {

    const [form, setForm] = useStateWithCallbackLazy(statisticsForm);
    const {dateInterval, companies} = form;

    useEffect(() => {
        onChangeForm({});
    }, [onChangeForm]);

    const handleChangeForm = useCallback((value) => {
        setForm({
            ...form,
            ...value
        }, null);
    }, [form]);
    function onChangeInterval(dateInterval) {
        handleChangeForm({
            dateInterval
        });
    }

    function onChangeCompanies(companies) {
        handleChangeForm({
            companies
        });
    }

    function handleSearch() {
        onChangeForm(form);
    }

    function handleClear() {
        setForm(FILM_RELEASE_REPORT_SEARCH_FORM, () => {
            onChangeForm(FILM_RELEASE_REPORT_SEARCH_FORM);
        });
    }


    return (
        <Grid2 container spacing={2}>
            <DateInterval defaultValue={dateInterval}
                onChange={onChangeInterval}/>
            <Grid2 container size={12}>
                <Grid2 size={{
                    sm: 12,
                    xs: 12,
                    md: 6,
                    lg: 5,
                    xl: 4
                }}>
                    <CompanySelect
                        defaultValue={companies}
                        multiple
                        placeholder={"All companies"}
                        onChange={onChangeCompanies}
                    />
                </Grid2>
            </Grid2>
            <Grid2 size={12}>
                <Button
                    onClick={handleSearch}
                    color={"secondary"}
                    style={{marginRight: 20}}
                    size={"small"}
                    variant={"contained"}
                >
                    Search
                </Button>
                <Button size={"small"} onClick={handleClear} variant={"contained"}>
                    Clear{" "}
                </Button>
            </Grid2>
        </Grid2>
    );
}

const FilmReleaseStatisticsForm = connect(({statistics}) => ({
    statisticsForm: statistics.filmReleaseForm
}), (dispatch) => ({
    onChangeForm: (form) => dispatch(actions.RUN_CATEGORY_REPORT_QUERY_REPORT.send(form)),
}))(FilmReleaseSearchFormView);
export default FilmReleaseStatisticsForm;
